import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProductGrid from '@/components/feature/ProductGrid';
import { products } from '@/mocks/products';

export default function ProductsPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-brand-500 to-brand-700 py-16 md:py-24">
          <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Modern%20e-commerce%20product%20showcase%20with%20luxury%20fashion%20items%20arranged%20on%20clean%20white%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20editorial%20photography%2C%20warm%20neutral%20tones&width=1600&height=400&seq=products-hero-bg&orientation=landscape')] bg-cover bg-center opacity-20" />
          <div className="relative max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
              {t('productsTitle', 'Product Catalog')}
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto">
              {t('productsSubtitle', 'Browse our curated collection of 100+ products from top brands. Click to buy on our main store.')}
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <a
                href="https://kaspreadsheet.com/index.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-6 py-3 bg-white text-brand-700 font-semibold rounded-lg hover:bg-warm-100 transition-colors"
              >
                CSSBuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/index.html"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-6 py-3 border-2 border-white/50 text-white font-semibold rounded-lg hover:bg-white/10 transition-colors"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-12 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <ProductGrid products={products} title={t('allProducts', 'All Products')} />
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 md:py-16 bg-warm-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-warm-900 mb-4">
              {t('ctaReady', 'Ready to shop?')}
            </h2>
            <p className="text-warm-700 mb-8">
              {t('ctaText', 'Visit our main store for the full catalog and latest arrivals.')}
            </p>
            <a
              href="https://kaspreadsheet.com/index.html"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-8 py-4 bg-brand-500 text-white font-semibold rounded-lg hover:bg-brand-600 transition-colors"
            >
              {t('visitStore', 'Visit Main Store')}
              <i className="ri-arrow-right-line ml-2" />
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}